/**
 * FRONTEND_HANDOFF.md §6 — admin uçlarının hata sözleşmesi: { code, name, message }.
 * Doküman "name alanına göre dallanın, message metnini birebir göstermeyin" diyor.
 */
const NAMED_ERRORS: Record<string, string> = {
  SELF_TARGET: "Bu işlemi kendi hesabınıza uygulayamazsınız.",
  LAST_ADMIN: "Sistemdeki son aktif admin bu işlemden korunuyor.",
  NAME_LOCKED_BY_KYC:
    "Ad/soyad kimlik doğrulamasıyla kilitlendi, bu alanlar değiştirilemez.",
};

const STATUS_FALLBACK: Record<number, string> = {
  400: "Gönderilen bilgilerde eksik ya da geçersiz alan var.",
  401: "Yetkiniz yok veya oturumunuz sonlanmış.",
  403: "Bu işlem için yetkiniz yok.",
  404: "Kayıt bulunamadı.",
  409: "İşlem mevcut durumla çakışıyor.",
  429: "Çok fazla deneme yapıldı, bir süre sonra tekrar deneyin.",
  500: "Sunucuda beklenmeyen bir hata oluştu.",
};

/**
 * RTK Query hatasını kullanıcıya gösterilebilir bir mesaja çevirir.
 * Önce `name` koduna, sonra HTTP durumuna bakar; ham `message` son çaredir.
 */
export const getAdminErrorMessage = (error: any): string => {
  const payload = error?.data ?? error;
  const name = payload?.name;

  if (name && NAMED_ERRORS[name]) return NAMED_ERRORS[name];

  const status = Number(error?.status ?? payload?.code);
  if (status && STATUS_FALLBACK[status]) return STATUS_FALLBACK[status];

  if (typeof payload?.message === "string" && payload.message.trim()) {
    return payload.message;
  }

  return "İşlem tamamlanamadı.";
};

export default getAdminErrorMessage;
